export default __webpack_public_path__ + "static/media/African-Nigerian-Couple-Love-Lovrican_mobile.14c091c6.webp";